import React, {useState} from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  Link,
  Stack,
  Text,
  VStack,
  Image,
  Center,
  Divider,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import apiClient from '../clients/apiClient.js';
import googleIcon from './googleIcon.svg';
import microsoftIcon from './microsoftIcon.svg';
import brandLoginLogo from './brandLoginLogo.svg';
import starLogo from './starLogo.svg';
import isoLogo from './isoLogo.svg';
import { useNavigate } from "react-router-dom";

import sslLogo from './sslLogo.svg';

import { IconButton } from "@mui/material";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';

const Login = () => {
  const [urls, setUrls] = React.useState(null);
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [code, setCode] = useState("");
  React.useEffect(() => {
    apiClient
      .get('/login/') // Base URL is already included
      .then((response) => {
        const data = response.data; // Access the response data
        console.log('API Response:', data); // Inspect the response

        // Construct URLs from the response data
        const googleURL = `${data.GoogleURL.Scheme}://${data.GoogleURL.Host}${data.GoogleURL.Path}?${data.GoogleURL.RawQuery}`;
        const microsoftURL = `${data.MicrosoftURL.Scheme}://${data.MicrosoftURL.Host}${data.MicrosoftURL.Path}?${data.MicrosoftURL.RawQuery}`;
        console.log('googleUrl', googleURL);

        // Update state with the URLs
        setUrls({ GoogleURL: googleURL, MicrosoftURL: microsoftURL });
      })
      .catch((error) => {
        console.error('Error during login:', error);
      });
  }, []);

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    apiClient
      .get(`/login/get-code?email=${email}`) // Base URL is already included
      .then((response) => {
        if (response.status !== 200) {
          alert("Something went wrong, please try again with other login routes")
        }
      })
    .catch((error) => {
        console.error('Error during login:', error);
      });
    setIsSubmitted(true); // Lock the email input and show the code input
  };

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    apiClient
      .get(`/login/verify-code?email=${email}&code=${code}`) // Base URL is already included
      .then((response) => {
        console.log("[Login] Response in login is", response)
        if (response.status === 302) {
          const redirectUrl = response.headers.location || "/login";
          window.location.href = redirectUrl; // Redirect manually
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          alert(error.response.data.error)
        }
        console.error('Error during login:', error);
      });
  };

  return (
    <Flex h="100vh" w={'100vw'} align="center" justify="center" bg="gray.100">
      <Flex
        bg="white"
        boxShadow="lg"
        rounded="lg"
        overflow="hidden"
        height={'100%'}
        w={'100%'}
      >
        {/* Left Section */}
        {/* E4F0FF */}
        {/* <Box> */}
          <Box flex="1" bg="#F6FAFF" paddingLeft={"2.75%"} paddingRight={'2.25%'} paddingTop={'180px'} maxW={"40%"}>
            {/* <Box flex="1" bg="#" p={20} paddingTop={'180px'}> */}

            <Image src={brandLoginLogo} alt="Thalamus Logo" marginLeft={-2} />
            <Text fontSize="2xl" fontWeight="bold" my={6} >
              Supercharge your revenue team with <br />Thalamus AI
            </Text>
            <VStack align="start" spacing={5} textAlign={'left'}>
              <Feature text="Simplify responses with everyday English prompts." />
              <Feature text="20+ specialized AI agents for RFx response optimization." />
              <Feature text="Access precise answers across millions of documents in seconds." />
              <Feature text="Connect effortlessly with email, chat, and data repositories." />
            </VStack>
          </Box>
        {/* </Box> */}

        {/* <Box flex="1" px={20} py={10} paddingTop={'180px'} maxW={"20%"}>

        </Box> */}
        {/* Right Section */}
        <Box flex="1" px={20} py={10} paddingTop={'180px'} maxW={"60%"}>
          <Box maxW={"80%"} justifySelf={"center"}>

          <Text fontSize="24px" fontWeight="semibold" mb={3} mt={1} align="left" ontFamily="'Inter', sans-serif" color={"#3D3D3D"}>
            Log in to Thalamus AI
          </Text>
          <Stack spacing={4}>
            <FormControl id="email">
              <Button
                as={Link}
                variant="outline"
                w="full"
                leftIcon={<Image src={googleIcon} />}
                size="lg"
                href={urls?.GoogleURL}
                _hover={{
                  textDecoration: "none",
                  backgroundColor: "#E4F0FF",
                }}
              >
                <Text fontWeight={500} textDecoration="none">Continue with Google</Text>
              </Button>
            </FormControl>
            <FormControl id="password">
              <Button
                as={Link}
                variant="outline"
                w="full"
                leftIcon={<Image src={microsoftIcon} />}
                size="lg"
                href={urls?.MicrosoftURL}
                _hover={{ 
                  textDecoration: "none",
                  backgroundColor: "#E4F0FF",
                }}
              >
                <Text fontWeight={500}>Continue with Microsoft</Text>
              </Button>
            </FormControl>

            <Flex align="center" my={4}>
              <Divider flex="1" />
              <Text mx={2} fontWeight="regular" color="#1D1D1D">
                OR
              </Text>
              <Divider flex="1" />
            </Flex>
            <Text color="#1D1D1D" fontSize={"14px"}>Email</Text>
            <Box p={0}>
              {!isSubmitted ? (
                <form onSubmit={handleEmailSubmit}>
                  <FormControl isRequired>
                    <Input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormControl>
                  <Button type="submit" color="white" bg="#2584FD" _hover={{bg:"#2584FD"}} mt={4} width="full">
                    Verify email
                  </Button>
                </form>
              ) : (
                <form onSubmit={handleCodeSubmit}>
                  <FormControl isDisabled>
                    <Input type="email" value={email} isDisabled />
                  </FormControl>
                  <FormControl isRequired mt={4}>
                    <Input
                      type="text"
                      placeholder="Enter the 6 digit code shared on email"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                    />
                  </FormControl>
                  <Button type="submit" colorScheme="green" mt={4} width="full">
                    Login
                  </Button>
                </form>
              )}
            </Box>
          </Stack>
            {' '}
            <Text mt={6} fontSize="sm" color="gray.600">
              New to Thalamus? See how we can boost your team's efficiency.{' '}
            {/* </Text> */}
          {/* </Center> */}
          {/* <Left> */}
            {/* <Text mt={0} fontSize="sm" color="gray.600"> */}
              <Link
                color="#0B5CFF"
                fontWeight={'bold'}
                href="https://calendly.com/harpreet-thalamushq/30min"
                target="_blank"
              >
                Book a demo
              </Link>
            </Text>
          <Center>
            <Text mt={2} fontSize="sm" color="gray.600" pt={40}>
              ©2024 Thalamus, Inc. All rights reserved.
              <Link
                href="https://thalamushq.ai/terms-conditions"
                px={'3px'}
                textDecoration={'underline'}
                fontWeight={600}
                target="_blank"
              >
                Terms of use
              </Link>
              and
              <Link
                href="https://thalamushq.ai/privacy-policy"
                paddingLeft={'3px'}
                textDecoration={'underline'}
                fontWeight={600}
                target="_blank"
              >
                Privacy policy
              </Link>
            </Text>
          </Center>

          <Flex justifyContent={'center'} paddingTop={4}>
            <Image src={starLogo} />
            <Image src={isoLogo} />
            <Image src={sslLogo} />
          </Flex>
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
};

const Feature = ({ text }) => (
  <Flex>
    <Box as="span" color="blue.500" mr={3}>
      <IconButton sx={{padding:0}}><CheckCircleOutlinedIcon sx={{padding:0, color:"#0B5CFF", fontSize:22}}/></IconButton>
    </Box>
    <Text fontWeight="500" color="#1d1d1d" fontSize="16px" fontFamily="'Inter', sans-serif" paddingTop={0.4}>{text}</Text>
  </Flex>
);

export default Login;
